(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lystia-pset')) {
    customElements.define('lystia-pset', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        try { this.data = JSON.parse(this.querySelector('[data-pset-data]').textContent); } catch (e) { this.data = {}; }
        var tpl = this.querySelector('[data-pset-total]');
        this.totalTpl = tpl ? tpl.innerHTML : '';
        this.onVariant = function (ev) {
          var v = self.data[String(ev.detail && ev.detail.id)];
          if (!v) return;
          if (v.g) self.querySelectorAll('[data-pset-g]').forEach(function (n) { n.textContent = v.g; });
          var sum = self.querySelector('[data-pset-sum]');
          if (sum && v.label && self.totalTpl) sum.textContent = self.totalTpl.replace('__V__', v.label);
        };
        document.addEventListener('variant:change', this.onVariant);
      }
      disconnectedCallback() { document.removeEventListener('variant:change', this.onVariant); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
